import React from "react";

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    // rendered above the title, e.g. a back link
    above?: React.ReactNode;
    // page actions on the right
    children?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, above, children }) => (
    <div className="page-header d-flex flex-wrap gap-3 justify-content-between align-items-start mb-4">
        <div>
            {above}
            <h1 className="page-header-title">{title}</h1>
            {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
        </div>
        {children}
    </div>
);

export default PageHeader;
